export const LOAD_OFFICE_LOCATIONS = 'load_office_locations';
export const OFFICE_LOCATIONS_LOADED = 'set_loaded_office_locations';
export const OFFICE_LOCATIONS_FAILED = 'office_locations_sync_error';

export const LOAD_PAYMENT_TERMS = 'load_payment_terms';
export const PAYMENT_TERMS_LOADED = 'set_loaded_payment_terms';
export const PAYMENT_TERMS_FAILED = 'payment_terms_sync_error';
export const RESET_PAYMENT_TERMS = 'reset_payment_terms';

export const LOAD_TRANSPORT_METHODS = 'load_transport_methods';
export const TRANSPORT_METHODS_LOADED = 'set_loaded_transport_methods';
export const TRANSPORT_METHODS_FAILED = 'transport_methods_sync_error';

export const RESET_METADATA = 'reset_metadata';
